import {
  createTheme,
  CssBaseline,
  PaletteMode,
  StyledEngineProvider,
  ThemeProvider,
  useMediaQuery,
} from '@mui/material';
import { blue } from '@mui/material/colors';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { Theme } from 'Types';

import { settingsAtom } from 'state/recoilState';

function AppThemeProvider({ children }: { children: React.ReactNode }) {
  const settings = useRecoilValue(settingsAtom);
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  const themeMap: Record<Theme, PaletteMode> = {
    [Theme.System]: prefersDarkMode ? 'dark' : 'light',
    [Theme.Light]: 'light',
    [Theme.Dark]: 'dark',
  };
  const mode = themeMap[settings.theme];

  const theme = React.useMemo(() => {
    return createTheme({
      palette: {
        mode,
        primary: {
          main: mode === 'light' ? blue[700] : blue[200],
        },
      },
    });
  }, [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <StyledEngineProvider injectFirst>{children}</StyledEngineProvider>
    </ThemeProvider>
  );
}

export default AppThemeProvider;
